import React from "react";
import { useNavigate } from 'react-router-dom';
//components
import Button from '../../Button';
//assets
import './style.scss';

const ErrorModal = ({ icon, title, text, userName, deleteButtonText, continueButtonText, setErrorModal }: any) => {
    const navigate = useNavigate();
    const handleClickDeleteBtn = () => {
        setErrorModal(false);
        navigate('/cotacoes-dashboard');
    };

    return (
        <>
            <div className="container-error">
                <div className="modalImg">
                    <img src={icon} />
                </div>
                <div className="modalErrorTitle">
                    <h1>{title}</h1>
                </div>
                <div className="modalErrorText">
                    <h2>{text}</h2>
                    <h2>Essa cotação está sendo manipulada pelo colaborador <span className="modalUserName">{userName}</span>. Recomendamos aguardar a finalização para não afetar o envio dos dados.</h2>
                </div>
                <div className="modalErrorButton">
                    <div className="deleteBtn">
                        <Button
                            label={deleteButtonText}
                            onClick={handleClickDeleteBtn}
                        ></Button>
                    </div>
                    <div className="continueBtn">
                        <Button
                            second
                            label={continueButtonText}
                            onClick={() => { setErrorModal(false); }}
                        ></Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ErrorModal;
